import { render, staticRenderFns } from "./LetterDocumentation.vue?vue&type=template&id=866c15f4"
import script from "./LetterDocumentation.vue?vue&type=script&lang=js"
export * from "./LetterDocumentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('866c15f4')) {
      api.createRecord('866c15f4', component.options)
    } else {
      api.reload('866c15f4', component.options)
    }
    module.hot.accept("./LetterDocumentation.vue?vue&type=template&id=866c15f4", function () {
      api.rerender('866c15f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/dispenseManagement/components/LetterDocumentation.vue"
export default component.exports